import { useDataProvider, useNotify, useRecordContext } from "ra-core";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import type { CrmDataProvider } from "../providers/types";
import type { Sale } from "../types";

export const ResendInvitationButton = () => {
  const record = useRecordContext<Sale>();
  const provider = useDataProvider<CrmDataProvider>();
  const notify = useNotify();
  const [pending, setPending] = useState(false);
  if (!record || record.disabled || !record.user_id) return null;
  return (
    <Button
      type="button"
      variant="outline"
      disabled={pending}
      onClick={async () => {
        setPending(true);
        try {
          await provider.resendInvitation(record.id);
          notify(
            "Приглашение передано почтовому серверу. Проверьте входящие и спам.",
            { type: "success" },
          );
        } catch (error) {
          notify((error as Error).message, { type: "error" });
        } finally {
          setPending(false);
        }
      }}
    >
      {pending ? "Отправка…" : "Повторить приглашение"}
    </Button>
  );
};
